import React from 'react';
import './App.css'; // Import SCSS file
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ProductionProcess from './pages/ProductionProcess.js';
import Research from './pages/Research';
import Contact from './pages/ContactUs.js';
import Future from './pages/Future';
import Products from './pages/Products';
import Agriculture from './pages/Agriculture';
import Animal from './pages/Animal';
import Microalgae from './pages/Microalgae';
import NewsEvents from './pages/NewsEvents';
import 'animate.css';


function App() {
  return (
    <Router>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/productionprocess" element={<ProductionProcess />} />
          <Route path="/research" element={<Research />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/future" element={<Future />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/agriculture" element={<Agriculture />} />
          <Route path="/products/animal" element={<Animal />} />
          <Route path="/microalgae" element={<Microalgae />} />
          <Route path="/news-events" element={<NewsEvents />} />
          /products/agriculture
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
